// extracted by mini-css-extract-plugin
export default {"wait-payment-activation-page":"styles_wait-payment-activation-page__YWlbF"};